<template>
  <auto-select
    v-bind="$attrs" 
    v-on="$listeners"
    style="min-width:200px"
    clear-icon="clear"
    :clearable="clearable"
    v-model="innerValue"
    :items="items"
    return-object
    :slots="true"
    :filter="filterFunc"
  >
    <template v-slot:selection="data">{{ displayFunc ? displayFunc(data.item, trans(data.item)) : trans(data.item) }}</template>
    <template v-slot:item="data">
      <v-list-item-content v-text="displayFunc ? displayFunc(data.item, trans(data.item)) : trans(data.item)"></v-list-item-content>
    </template>
  </auto-select>
</template>

<script>
import { mapGetters } from "vuex";
import { translate2 } from "../trans2";
import AutoSelect from "../components/AutoSelect";
export default {
  props: [
    "value",
    "items",
    "clearable",
    "displayFunc"
  ],
   components:{
    AutoSelect
  },
  mounted() {},
  data() {
    return {
      innerValue: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"])
  },
  watch: {
    value: {
      handler(v) {
        this.innerValue = v;
      }, immediate: true
    },
    innerValue: {
      handler(v) {
        this.$emit("update:value",v);
        this.$emit('change', v)
      }
    },
  },
  methods: {
    filterFunc(item, search) {
      return this.trans(item).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    trans(item) {
      return translate2(item, "Name");
    }
  },
};
</script>